<div class="card-header" id="listeAppelsHeader">
    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
        data-target="#listeAppelsCollapse" aria-expanded="true" aria-controls="listeAppelsCollapse">
        Rechercher une liste d'appels
    </button>
</div>

<div id="listeAppelsCollapse" class="panel-collapse collapse" aria-labelledby="listeAppelsHeader"
    data-parent="#accordionExtraction">

    <div class="card-body row">
        <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="wrapper shadowed">
            <h4>Rechercher une liste d'appels</h4>
            <br>
            <div class="paragraphe">
                <mat-form-field>
                    <input matInput [matDatepicker]="picker" placeholder="Date de début"
                        formControlName="startDate">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker startView="month"></mat-datepicker>
                </mat-form-field>
                <mat-form-field>
                    <input matInput [matDatepicker]="picker1" placeholder="Date de fin"
                        formControlName="endDate">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1 startView="month"></mat-datepicker>
                </mat-form-field>
            </div>

            <div class="paragraphe">
                <mat-form-field>
                    <input matInput [matDatepicker]="mesDate" placeholder="Mise en service après"
                        formControlName="dateMiseEnService">
                    <mat-datepicker-toggle matSuffix [for]="mesDate"></mat-datepicker-toggle>
                    <mat-datepicker #mesDate startView="month"></mat-datepicker>
                </mat-form-field>

            </div>

            <div class="paragraphe">
                <mat-form-field>
                    <mat-select formControlName="contractType" placeholder="Type de contrat">
                        <mat-option>Tous</mat-option>
                        <mat-option *ngFor="let type of typesContrat" [value]="type.ID_CONTRAT_SAV">
                            {{type.NOM_CONTRAT}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="paragraphe">
                <mat-form-field>
                    <mat-select formControlName="type" placeholder="Type d'appel">
                        <mat-option *ngFor="let app of listeTypeAppels" [value]="app.type_appel_name">{{
                            app.type_appel_name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="paragraphe">
                <mat-form-field>
                    <mat-select formControlName="action" placeholder="Action">
                        <mat-option *ngFor="let action of listeActionsSav" [value]="action.action_name">{{
                            action.action_name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="paragraphe">
                <mat-form-field>
                    <mat-select formControlName="intervenant" placeholder="Intervenant">
                        <mat-option *ngFor="let intervenant of listeIntervenantsSav"
                            [value]="intervenant.intervenant_name"> {{ intervenant.intervenant_name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="paragraphe">
                <mat-form-field>
                    <mat-select formControlName="codePanne" placeholder="Code Zone">
                        <input (keyup)="onKey($event)" placeholder="Chercher...">
                        <mat-option>Tous</mat-option>
                        <mat-option *ngFor="let code of selectedPannes" [value]="code.code">{{code.code}} :
                            {{code.nom}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="paragraphe">
                <mat-form-field>
                    <mat-select formControlName="technicienSav" placeholder="Technicien" multiple>
                        <mat-option *ngFor="let tech of listTechniciensSav" [value]="tech.ID_PERSONNE" >
                            {{ tech.NOM }} {{ tech.PRENOM }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="paragraphe">
                <mat-form-field>
                    <mat-select formControlName="departement" placeholder="Département" multiple>
                        <mat-option *ngFor="let dept of listDepartement" [value]="dept.DEPT" >
                            {{ dept.DEPT }} 
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="paragraphe">
                <mat-form-field>
                    <mat-select formControlName="validation" placeholder="Validation">
                        <mat-option value="Tous">Tous</mat-option>
                        <mat-option value="Sans">Non vérifié</mat-option>
                        <mat-option value="Avec">Vérifié</mat-option>
                        <mat-option value="OK">OK</mat-option>
                        <mat-option value="NOK">NOK</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <button type="submit" class="btn btn-primary" style="margin-left: 40px;">Valider</button>

        </form>
        <br><br>

        <app-gmao-spinner *ngIf="isLoading"></app-gmao-spinner>


        <ng-container *ngIf="callStats">
            <div class="wrapper shadowed">

                <br />

                <h4>Résultats</h4>

                <app-export-button [data]="callStats"></app-export-button>

                <br />

                <ng-container *ngIf="callStats">
                    <p>Total pour la période sélectionée : <span class="count-total">{{callStats.length}}</span>
                    </p>
                </ng-container>

                <mat-table [dataSource]="callStats">
                    <ng-container matColumnDef="date">
                        <mat-header-cell *matHeaderCellDef> Date </mat-header-cell>
                        <mat-cell *matCellDef="let call"> {{getNiceDateHeure(call.DEBUT)}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="numSerie">
                        <mat-header-cell *matHeaderCellDef> Numéro de série </mat-header-cell>
                        <mat-cell *matCellDef="let call"> {{call.NUMERO}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="nom">
                        <mat-header-cell *matHeaderCellDef> Hotliner </mat-header-cell>
                        <mat-cell *matCellDef="let call"> {{call.HOTLINER}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
                        <mat-cell *matCellDef="let call"> {{call.ACTION}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="contrat">
                        <mat-header-cell *matHeaderCellDef> Contrat </mat-header-cell>
                        <mat-cell *matCellDef="let call"> {{call.CONTRAT}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="duree">
                        <mat-header-cell *matHeaderCellDef> Durée (minutes) </mat-header-cell>
                        <mat-cell *matCellDef="let call"> {{call.DUREE}} </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="dateMiseEnService">
                        <mat-header-cell *matHeaderCellDef> Date de mise en service </mat-header-cell>
                        <mat-cell *matCellDef="let call"> {{getNiceDate(call.DATE_DE_MISE_EN_SERVICE)}} </mat-cell>
                    </ng-container>
                    
                    <ng-container matColumnDef="departement">
                        <mat-header-cell *matHeaderCellDef> Département </mat-header-cell>
                        <mat-cell *matCellDef="let call"> {{call.DEPT}} </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="callState">
                        <mat-header-cell *matHeaderCellDef> Validation </mat-header-cell>
                        <mat-cell *matCellDef="let call"> <ng-container *ngIf="call.state_time"> <span *ngIf="call.call_state" class="ok" >OK </span>
                        <span *ngIf="!call.call_state" class="nok" >NOK </span> par {{call.superviseur}}</ng-container>  </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumn"></mat-header-row>
                    <mat-row
                        *matRowDef="let row; columns: ['date', 'numSerie', 'nom', 'action', 'contrat', 'duree', 'dateMiseEnService', 'departement', 'callState'] ;"
                        (click)="clickCall(row)"></mat-row>
                </mat-table>
            </div>
        </ng-container>
        <br />
    </div>

</div>